var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('vertical-nav-menu-items',{staticClass:"navigation navigation-main",attrs:{"items":_vm.itemMenuGroup}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }